import { WhatsappLogo } from "@phosphor-icons/react";

const OFFICE_WA = "971557396664"; // +971 55 739 6664

export default function WhatsAppButton({ message, phone, className = "", testId = "whatsapp-btn" }) {
  const number = (phone || OFFICE_WA).replace(/\D/g, "");
  const text = encodeURIComponent(message || "Hi Point Penta — I'd like to enquire about a property.");
  const href = `https://wa.me/${number}?text=${text}`;
  return (
    <a
      href={href} target="_blank" rel="noopener noreferrer"
      data-testid={testId}
      className={`inline-flex items-center justify-center gap-2 px-5 py-3 bg-[#25D366] text-black tracking-wide hover:bg-white transition-colors ${className}`}
    >
      <WhatsappLogo size={18} weight="fill" /> Chat on WhatsApp
    </a>
  );
}
